<template>
  <base-section
    id="partners"
  >
    <v-container
    fluid
    >
      <base-section-heading title="Partner Conferences & Workshops" />
      <v-slide-group
        id="mover_partners"
      >
        <template v-for="(partner, i) in partners">
          <v-slide-item
            :key="i"
            class="align-self-center"
          >
            <a
              :href="partner.to"
              target="_blank"
            >
              <base-img
                v-bind="partner"
                color="grey"
                contain
                height="50"
                width="128"
              />
            </a>
          </v-slide-item>

          <v-responsive
            v-if="i < 16"
            :key="`divider-${i}`"
            class="text-center"
            height="56"
            width="30"
          >
            <v-divider vertical />
          </v-responsive>
        </template>
      </v-slide-group>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAffiliates',
    data: () => ({
      partners: [
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
        {
          src: require('@/assets/partner-1-light.png'),
          to: 'https://www.itc-asia.info.hiroshima-cu.ac.jp/2023/',
        },
        {
          src: require('@/assets/partner-2-light.png'),
          to: 'https://www-elec.inaoep.mx/~LATS2023/',
        },
        {
          src: require('@/assets/partner-3-light.png'),
          to: 'https://www.swtest.org/',
        },
        {
          src: require('@/assets/partner-4-light.png'),
          to: 'https://orion.polito.it/iolts/',
        },
        {
          src: require('@/assets/partner-5-light.jpg'),
          to: 'https://www.mdpi.com/journal/sensors',
        },
        {
          src: require('@/assets/partner-6-light.png'),
          to: 'https://pesw.fit.cvut.cz/2023/',
        },
        {
          src: require('@/assets/partner-7-light.png'),
          to: 'https://ddecs2023.taltech.ee/',
        },
        {
          src: require('@/assets/partner-8-light.png'),
          to: 'https://www.ufrgs.br/isvlsi2023/',
        },
        {
          src: require('@/assets/partner-9-light.png'),
          to: 'https://nordictestforum.org/',
        },
      ],
    }),
    mounted () {
      if (document.getElementById('mover_partners')) {
        //  document.getElementById('mover_partners').children[1].style.overflow = 'visible'
        document.getElementById('mover_partners').children[1].style.whiteSpace = 'no-wrap'
        //  document.getElementById('mover').children[1].style.width = '176'
        document.getElementById('mover_partners').children[1].children[0].classList.add('mover')
      }
    },
  }
</script>
